import React, { PureComponent } from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import PropTypes from 'prop-types';

import { reduxForm as reduxFormSelector } from 'ggApp/modules/form/selectors';

// Components
import SettingsFormSection from './formSection';
import { Form } from './styles';

export const SETTINGS_FORM_TYPE = 'cookiePolicySettingsForm';

/**
 * CookiePolicySettingsForm
 * This form provides to the user an ability
 * to specify which cookie types are allowed to use.
 * @class CookiePolicySettingsForm
 * @extends {Component}
 */

class CookiePolicySettingsForm extends PureComponent {
    render() {
        const { onSubmit, handleSubmit } = this.props;

        return (
            <Form onSubmit={handleSubmit(onSubmit)}>
                <SettingsFormSection
                    disabled
                    fieldName="mandatoryCookie"
                    headerTranslationKey="COOKIE_POLICY_MANDATORY_HEADER_TEXT"
                    textTranslationKey="COOKIE_POLICY_MANDATORY_TEXT"
                    labelTranslationKey="COOKIE_POLICY_MANDATORY_TOGGLE_LABEL"
                />

                <SettingsFormSection
                    fieldName="preferenceCookie"
                    headerTranslationKey="COOKIE_POLICY_PREFERENCES_HEADER_TEXT"
                    textTranslationKey="COOKIE_POLICY_PREFERENCES_TEXT"
                    labelTranslationKey="COOKIE_POLICY_PREFERENCES_TOGGLE_LABEL"
                />

                <SettingsFormSection
                    fieldName="statisticsCookie"
                    headerTranslationKey="COOKIE_POLICY_STATISTICS_HEADER_TEXT"
                    textTranslationKey="COOKIE_POLICY_STATISTICS_TEXT"
                    labelTranslationKey="COOKIE_POLICY_STATISTICS_TOGGLE_LABEL"
                />

                <SettingsFormSection
                    fieldName="marketingCookie"
                    headerTranslationKey="COOKIE_POLICY_MARKETING_HEADER_TEXT"
                    textTranslationKey="COOKIE_POLICY_MARKETING_TEXT"
                    labelTranslationKey="COOKIE_POLICY_MARKETING_TOGGLE_LABEL"
                />
            </Form>
        );
    }
}

CookiePolicySettingsForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
};

const enhance = compose(
    connect((state) => ({
        initialValues: {
            mandatoryCookie: true,
            preferenceCookie: state?.cookiePolicy?.consentState?.preferenceCookieConsent,
            statisticsCookie: state?.cookiePolicy?.consentState?.statisticsCookieConsent,
            marketingCookie: state?.cookiePolicy?.consentState?.marketingCookieConsent,
        },
    })),
    reduxForm({
        getFormState: (state) => reduxFormSelector(state),
        form: SETTINGS_FORM_TYPE,
        enableReinitialize: true,
    }),
);

export default enhance(CookiePolicySettingsForm);
